/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInstanceIngestionFilterRequest
 */
export interface UpdateInstanceIngestionFilterRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInstanceIngestionFilterRequest
     */
    ingestionFilterRuleId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInstanceIngestionFilterRequest
     */
    ingestionFilterRuleConfig?: string;
}

/**
 * Check if a given object implements the UpdateInstanceIngestionFilterRequest interface.
 */
export function instanceOfUpdateInstanceIngestionFilterRequest(value: object): value is UpdateInstanceIngestionFilterRequest {
    return true;
}

export function UpdateInstanceIngestionFilterRequestFromJSON(json: any): UpdateInstanceIngestionFilterRequest {
    return UpdateInstanceIngestionFilterRequestFromJSONTyped(json, false);
}

export function UpdateInstanceIngestionFilterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInstanceIngestionFilterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ingestionFilterRuleId': json['ingestionFilterRuleId'] == null ? undefined : json['ingestionFilterRuleId'],
        'ingestionFilterRuleConfig': json['ingestionFilterRuleConfig'] == null ? undefined : json['ingestionFilterRuleConfig'],
    };
}

export function UpdateInstanceIngestionFilterRequestToJSON(json: any): UpdateInstanceIngestionFilterRequest {
    return UpdateInstanceIngestionFilterRequestToJSONTyped(json, false);
}

export function UpdateInstanceIngestionFilterRequestToJSONTyped(value?: UpdateInstanceIngestionFilterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ingestionFilterRuleId': value['ingestionFilterRuleId'],
        'ingestionFilterRuleConfig': value['ingestionFilterRuleConfig'],
    };
}

